import { Divider } from '@mui/material';
import { SectionSkeleton } from 'components/shared/MultiStepForm/Skeletons/SectionSkeleton';
import useGetAuxValueById from '../hooks/useGetAuxValueById';
import AuxValuesForm from './AuxValuesForm';

import type { IAuxValuesFormProps } from './AuxValuesForm';

interface AuxValuesEditForm extends Omit<IAuxValuesFormProps, 'rowId'> {
  rowId: number | string;
}

const AuxValuesEditForm = ({ handleClose, rowId }: AuxValuesEditForm) => {
  'use memo';

  const { isFetching, resource } = useGetAuxValueById(Number(rowId));
  return isFetching ? (
    <div>
      <SectionSkeleton height={270} width={400} />
      <Divider />
      <SectionSkeleton width={400} />
    </div>
  ) : (
    <AuxValuesForm
      handleClose={handleClose}
      rowId={resource?.auxValueId}
      auxValue={resource}
    />
  );
};

export default AuxValuesEditForm;
